module.exports = __webpack_public_path__ + "img/chengdesc.43adb75e.jpg";